/**
 * Descriptors HTTP service (PX-W6.5) — the two org-less, plain
 * `@Authenticated` descriptor reads.
 *
 * ⚠ 404 `descriptor.not-found: <kind>` when the kind has no rows — the
 * catalogue renders its error state with retry, NEVER a demo fallback
 * standing in for live data (AC-6).
 */

import { apiClient } from '@/services'

import { asAgentDescriptor, type AgentDescriptor, type TaskStatusDescriptor } from '../types'

export const descriptorsService = {
  /**
   * The agent descriptors, normalised through the key-resolving guard
   * (`id`, `slug` fallback) — malformed rows are dropped, not rendered
   * half-empty.
   */
  agents(): Promise<AgentDescriptor[]> {
    return apiClient.get<unknown[]>('/descriptors/agents').then((rows) =>
      rows
        .map(asAgentDescriptor)
        .filter((row): row is AgentDescriptor => row !== null)
    )
  },

  /** The task-status vocabulary (for consumers of the status set). */
  taskStatuses(): Promise<TaskStatusDescriptor[]> {
    return apiClient.get<TaskStatusDescriptor[]>('/descriptors/task-statuses')
  }
}
